import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { fetchTraceGraphBySalesOrderId } from '@/api/orders';

export const traceGraphKeys = {
  all: ['traceGraph'] as const,
  detail: (soId: string) => [...traceGraphKeys.all, soId] as const,
};

export function useTraceGraphBySalesOrderId(soId: string) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: traceGraphKeys.detail(soId),
    queryFn: () => fetchTraceGraphBySalesOrderId(soId).then(res => res.data),
    enabled: !!soId,
  });

  const isProcessing =
    query.data?.order?.aiSummary?.scAnalysis?.status === 'PROCESSING';

  useEffect(() => {
    if (!isProcessing) return;
    const interval = setInterval(() => {
      void queryClient.invalidateQueries({
        queryKey: traceGraphKeys.detail(soId),
      });
    }, 20_000);
    return () => clearInterval(interval);
  }, [isProcessing, soId, queryClient]);

  return query;
}
